import { h, Fragment } from "preact";
import stockMessage from "../../helpers/stockMessage/stockMessage";
import StockMessageContent from "./stock-message-content";
import dayjs from "dayjs";

const convertToCST = (dateString) =>
  dateString ? `${dateString}T12:00-06:00` : dateString;

const whenInMonth = (day) => (day < 16 ? "early" : "late");

const formatExactDate = (dateString) => {
  if (!dateString) return null;

  const date = dayjs(new Date(convertToCST(dateString)));

  return date.format(`[${whenInMonth(date.date())}] MMM YYYY`);
};

const formatEstimatedDate = (dateString) => {
  if (!dateString) return null;

  const date = dayjs(new Date(convertToCST(dateString)));

  return date.format(`[${whenInMonth(date.date())}] MMM YYYY`);
};

export default function StockMessage({
  availableForSale,
  quantityAvailable,
  lowStockThreshold,
  dnr,
  cargoReady,
  backorderDate,
  localeStrings,
  madeToOrder,
}) {
  const interpolateDate = (string) => {
    return string
      .replace("[exact_date]", formatExactDate(backorderDate))
      .replace("[estimated_date]", formatEstimatedDate(backorderDate));
  };

  const messages = {
    inStock: {
      elevarName: "In Stock",
      attributeValue: "inStock",
      tooltip: localeStrings.tooltip_in_stock,
      lines: [
        {
          text: localeStrings.in_stock.line_1,
          color: "var(--color-secondary)",
        },
      ],
    },
    lowStock: {
      elevarName: "Low Stock",
      attributeValue: "lowStock",
      tooltip: localeStrings.tooltip_low_stock,
      lines: [
        {
          text: interpolateDate(localeStrings.low_stock.line_1),
          color: "var(--color-secondary)",
        },
      ],
    },
    outOfStock: {
      elevarName: "Out of Stock",
      attributeValue: "outOfStock",
      tooltip: null,
      lines: [
        {
          text: interpolateDate(localeStrings.out_of_stock.line_1),
          color: "var(--color-tertiary)",
        },
      ],
    },
    reserveNow: {
      elevarName: "Backordered",
      attributeValue: "reserveNow",
      tooltip: localeStrings.tooltip_out_of_stock,
      lines: [
        {
          text: interpolateDate(localeStrings.reserve_now.line_1),
          color: "var(--color-tertiary)",
        },
      ],
    },
    reserveNowDate: {
      elevarName: "Backordered",
      attributeValue: "reserveNowDate",
      tooltip: localeStrings.tooltip_out_of_stock,
      lines: [
        {
          text: interpolateDate(localeStrings.reserve_now_date.line_1),
          color: "var(--color-tertiary)",
        },
        {
          text: interpolateDate(localeStrings.reserve_now_date.line_2),
        },
      ],
    },
    notifyMe: {
      elevarName: "Notify Me",
      attributeValue: "notifyMe",
      tooltip: localeStrings.tooltip_out_of_stock,
      lines: [
        {
          text: interpolateDate(localeStrings.notify_me.line_1),
          color: "var(--color-tertiary)",
        },
      ],
    },
    notifyMeDate: {
      elevarName: "Notify Me",
      attributeValue: "notifyMeDate",
      tooltip: localeStrings.tooltip_out_of_stock,
      lines: [
        {
          text: interpolateDate(localeStrings.notify_me_date.line_1),
          color: "var(--color-tertiary)",
        },
        {
          text: interpolateDate(localeStrings.notify_me_date.line_2),
        },
      ],
    },
    madeToOrder: {
      elevarName: "Made to Order",
      attributeValue: "madeToOrder",
      tooltip: localeStrings.tooltip_made_to_order,
      lines: [
        {
          text: interpolateDate(localeStrings.made_to_order.line_1),
          color: "var(--color-tertiary)",
        },
        {
          text: interpolateDate(localeStrings.made_to_order.line_2),
        },
      ],
    },
  };

  const message = stockMessage({
    availableForSale,
    quantityAvailable,
    lowStockThreshold,
    dnr,
    cargoReady,
    backorderDate,
    messages,
    madeToOrder,
  });

  return <StockMessageContent message={message} />;
}
